<template>
  <div class="dashboard-financeiro container">
    <div class="saldo mb-4">
      <div>
        <span class="fw-bold text-muted">Saldo em conta</span>
        <div class="d-flex align-items-center gap-2 mt-1">
          <span class="display-4 text-success">
            {{
              mostrarSaldo
                ? "R$ " + numberToReal(dados.saldo_em_conta, 2)
                : "••••••"
            }}
          </span>
          <b-button
            style="margin-left: 10px"
            variant="link"
            class="p-0 ms-2"
            @click="alternarSaldo"
            v-b-tooltip.hover.right="'Esconder valores'"
          >
            <b-icon
              :icon="mostrarSaldo ? ' eye-slash' : ' eye'"
              font-scale="1.5"
            />
          </b-button>
        </div>
      </div>
    </div>

    <div
      class="d-flex flex-wrap align-items-center justify-content-between mb-3"
      style="gap: 1rem"
    >
      <div class="d-flex align-items-center" style="gap: 1rem">
        <b-dropdown
          id="filtro-periodo"
          :text="labelPeriodo"
          variant="outline-primary"
          class="me-2"
        >
          <b-dropdown-item @click="setFiltro('day')">Hoje</b-dropdown-item>
          <b-dropdown-item @click="setFiltro('week')"
            >Esta semana</b-dropdown-item
          >
          <b-dropdown-item @click="setFiltro('month')"
            >Este mês</b-dropdown-item
          >
          <b-dropdown-item @click="setFiltro('year')">Este ano</b-dropdown-item>
          <b-dropdown-item @click="setFiltro('personalizado')"
            >Personalizado</b-dropdown-item
          >
        </b-dropdown>

        <div
          v-if="filtroPeriodo === 'personalizado'"
          class="d-flex align-items-center"
          style="gap: 0.5rem"
        >
          <b-form-datepicker
            v-model="dataInicio"
            placeholder="Início"
            class="w-auto"
            size="sm"
          />
          <b-form-datepicker
            v-model="dataFim"
            placeholder="Fim"
            class="w-auto"
            size="sm"
          />
          <b-button size="sm" variant="primary" @click="buscarDadosDashboard">
            <b-icon icon="funnel-fill" class="mr-1" /> Aplicar
          </b-button>
        </div>
      </div>

      <!-- <b-button variant="success" @click="mostrarModalTransferencia = true">
        <b-icon icon="arrow-right-circle" class="mr-2" /> Transferir Pix
      </b-button> -->
    </div>

    <b-row class="mb-4">
      <InfoBox
        cor="success"
        titulo="Recebidas"
        icone="check-circle"
        :valor="dados.recebidas.valor_total"
        :liquido="dados.recebidas.liquido"
        :clientes="dados.recebidas.clientes"
        :cobrancas="dados.recebidas.cobrancas"
        tituloBIcon="Cobranças recebidas dentro do período"
      />
      <InfoBox
        cor="primary"
        titulo="Confirmadas"
        icone="check"
        :valor="dados.confirmadas.valor_total"
        :liquido="dados.confirmadas.liquido"
        :clientes="dados.confirmadas.clientes"
        :cobrancas="dados.confirmadas.cobrancas"
        tituloBIcon="Cobranças recebidas dentro do período, mas que estão aguardando o repasse."
      />
      <InfoBox
        cor="warning"
        titulo="Aguardando pagamento"
        icone="clock"
        :valor="dados.aguardando_pagamento.valor_total"
        :liquido="dados.aguardando_pagamento.liquido"
        :clientes="dados.aguardando_pagamento.clientes"
        :cobrancas="dados.aguardando_pagamento.cobrancas"
        tituloBIcon="Cobranças previstas para recebimento dentro do período."
      />
      <InfoBox
        cor="danger"
        titulo="Vencidas"
        icone="x-circle"
        :valor="dados.vencidas.valor_total"
        :liquido="dados.vencidas.liquido"
        :clientes="dados.vencidas.clientes"
        :cobrancas="dados.vencidas.cobrancas"
        tituloBIcon="Cobranças vencidas dentro do período e que não foram pagas."
      />
      <ExtratoFinanceiro
        :filtroPeriodo="filtroPeriodo"
        :dataInicio="dataInicio"
        :dataFim="dataFim"
      />
    </b-row>

    <b-modal
      v-model="mostrarModalTransferencia"
      title="Transferência Pix"
      hide-footer
    >
      <p>
        As 30 primeiras Transferências ou Pix do mês são gratuitas, depois disso
        será cobrada uma taxa de R$ 2,00 para Pix com chave ou manual.
      </p>
      <b-form @submit.prevent="enviarTransferencia">
        <b-form-group label="Tipo da Chave">
          <b-form-select
            v-model="transferencia.tipo"
            :options="tiposChave"
            required
          />
        </b-form-group>

        <b-form-group label="Chave Pix">
          <b-form-input v-model="transferencia.chave" required />
        </b-form-group>

        <b-form-group label="Valor">
          <money
            class="form-control"
            v-model="transferencia.valor"
            v-bind="configMoney"
            required
          />
        </b-form-group>

        <b-form-group label="Descrição">
          <b-form-textarea v-model="transferencia.descricao" rows="3" />
        </b-form-group>

        <div class="d-flex justify-content-end">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="mostrarModalTransferencia = false"
            >Cancelar</b-button
          >
          <b-button variant="primary" type="submit"
            >Confirmar Transferência</b-button
          >
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import InfoBox from "@/components/InfoBox/InfoBox.vue";
import ExtratoFinanceiro from "@/components/ExtratoFinanceiro/ExtratoFinanceiro.vue";
import { SistemaMixin } from "@/modules/Application";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";

export default {
  name: "DashboardFinanceiro",
  mixins: [SistemaMixin],
  components: {
    InfoBox,
    ExtratoFinanceiro,
    Money,
  },
  data() {
    return {
      filtroPeriodo: "month",
      filtroStatus: "todas",
      dataInicio: null,
      dataFim: null,
      mostrarSaldo: false,
      mostrarModalTransferencia: false,
      transferencia: {
        tipo: "EMAIL",
        chave: "",
        valor: null,
        descricao: "",
      },
      tiposChave: [
        { value: "EMAIL", text: "E-mail" },
        { value: "CPF", text: "CPF" },
        { value: "CNPJ", text: "CNPJ" },
        { value: "PHONE", text: "Telefone" },
      ],
      configMoney: settingMoney,
      dados: {
        saldo_em_conta: 0,
        recebidas: { valor_total: 0, liquido: 0, clientes: 0, cobrancas: 0 },
        confirmadas: { valor_total: 0, liquido: 0, clientes: 0, cobrancas: 0 },
        aguardando_pagamento: {
          valor_total: 0,
          liquido: 0,
          clientes: 0,
          cobrancas: 0,
        },
        vencidas: { valor_total: 0, liquido: 0, clientes: 0, cobrancas: 0 },
      },
    };
  },
  computed: {
    labelPeriodo() {
      switch (this.filtroPeriodo) {
        case "day":
          return "Hoje";
        case "month":
          return "Este Mês";
        case "week":
          return "Esta semana";
        case "year":
          return "Este ano";
        case "personalizado":
          return "Personalizado";
        default:
          return "Período";
      }
    },
  },
  mounted() {
    this.buscarDadosDashboard();
  },
  methods: {
    alternarSaldo() {
      this.mostrarSaldo = !this.mostrarSaldo;
    },
    setFiltro(periodo) {
      this.filtroPeriodo = periodo;
      this.dataInicio = null;
      this.dataFim = null;
      if (periodo !== "personalizado") this.buscarDadosDashboard();
    },
    async buscarDadosDashboard() {
      try {
        const response = await this.$http.post("/bancos/dashboard-financeiro", {
          periodo: this.filtroPeriodo,
          dataInicio: this.dataInicio,
          dataFim: this.dataFim,
        });
        this.dados = response.data;
      } catch (error) {
        console.error("Erro ao buscar dados do dashboard:", error);
      }
    },
    aplicarFiltro(status) {
      this.filtroStatus = status;
      this.buscarDadosDashboard();
    },
    async enviarTransferencia() {
      try {
        await this.$http.post(
          "/bancos/enviar-transferencia",
          this.transferencia
        );
        this.$toast.success("Transferência realizada com sucesso!");
        this.mostrarModalTransferencia = false;
      } catch (e) {
        this.$toast.warning("Erro ao realizar transferência");
      }
    },
  },
};
</script>

<style scoped>
.dashboard-financeiro {
  padding: 2rem 1rem;
}
.dropdown-menu-left {
  transform: translateX(-30%);
  max-width: 220px;
  min-width: 200px;
}
</style>
